import { DivisiResponse } from "../../../../models/Divisi";
import { PendidikanResponse } from "../../../../models/Pendidikan";
import { getApiInstance } from "../../../api";
import mutationWrapper from "../../mutationWrapper";
import ApiClient from "../../../apiClient";

export async function pendidikan(
  PENDIDIKAN_ID: number
): Promise<PendidikanResponse> {
  const res = await ApiClient.get(
    `/PendidikanSelectionDetail?PENDIDIKAN_ID=${PENDIDIKAN_ID}`
  );
  return res.data[0];
}

export const useFetchPendidikan = mutationWrapper(pendidikan);
